/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  ChangeDetectionStrategy
} from '@angular/core';

declare let jQuery;
@Component({
  selector: 'app-ctv-channels',
  templateUrl: './ctv-channels.component.html',
  styleUrls: ['./ctv-channels.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CtvChannelsComponent implements OnChanges {
  @Input() data: any;
  @Input() isFreemium: boolean;

  limit = 18;
  showChannels: Array<any>;
  totalItems = 0;

  ngOnChanges(changes: SimpleChanges): void {
    for (const propName in changes) {
      if (propName === 'data') {
        this.data.channelDistribution.forEach(channel => {
          channel.imgSrc = `//cdn.pixalate.com/channel_icons/roku/${channel.channelId}.png`;
        });
        this.showChannels = [];
        this.totalItems = this.data.channelDistribution.length;
        this.updateChannels();
      }
    }
  }

  updateChannels(currentIndex = 0) {
    const newChannels = [];
    for (let i = currentIndex; i < currentIndex + this.limit; i++) {
      if (this.data.channelDistribution[i]) {
        const newChannel = this.data.channelDistribution[i];
        newChannel.imgSrc = `//cdn.pixalate.com/channel_icons/roku/${this.data.channelDistribution[i].channelId}.png`;
        newChannels.push(newChannel);
      } else {
        newChannels.push({
          imgSrc: '',
          channelName: 'N/A'
        });
      }
    }
    this.showChannels = newChannels;
  }

  imageLoadError($event) {
    const imgSrc = jQuery($event.currentTarget).attr('src');
    if (imgSrc.endsWith('.png')) {
      jQuery($event.currentTarget).attr('src', imgSrc.replace('.png', '.jpg'));
    } else if (imgSrc.endsWith('.jpg')) {
      jQuery($event.currentTarget).attr(
        'src',
        '/assets/images/logo-grey-16x16.png'
      );
    }
  }
}
